import config from "@/config"
import http from "@/utils/request"
import tool from "@/utils/tool"
export default {
  store: {
    admin: {
      url: `${config.API_URL}/store`,
      name: "获取菜单",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      closeStore: async function (data) {
        return await http.post(`${this.url}/admin/closeStore`, data) //闭店
      },
      openStore: async function (data) {
        return await http.post(`${this.url}/admin/openStore`, data) //闭店
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      },
      getStoreCategorys: async function (data) {
        return await http.get(`${config.API_URL}/dict/getDictByCode?code=storeType`, data) //获取店铺主营类目列表
      },
      applyStore: async function (data) {
        return await http.post(`${config.API_URL}/application/store/apply`, data)
      },
      getApplyStoreInfo: async function (data) {
        return await http.post(`${config.API_URL}/application/store/getApplyInfo`, data)
      }
    },
    owner: {
      url: `${config.API_URL}`,
      name: "店主",
      update: async function (params) {
        return await http.get(`${this.url}/store/owner/update`, params)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/product/store/updataStatus`, data)
      }
    }
  },
  storeRule: {
    list: {
      url: `${config.API_URL}/store/rule`,
      name: "获取店铺规则",
      get: async function (params) {
        return await http.get(`${this.url}/getRulesByStoreId`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, { ...data, storeId: tool.data.get("USER_INFO").storeId })
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, { ...data, storeId: tool.data.get("USER_INFO").storeId })
      }
    }
  },
  product: {
    admin: {
      url: `${config.API_URL}/product`,
      name: "获取商品",
      get: async function (params) {
        return await http.get(`${this.url}/manage/list`, params)
      },
      toReviewList: async function (params) {
        return await http.get(`${this.url}/manage/toReviewList`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      },
      review: async function (data) {
        return await http.post(`${this.url}/manage/review`, data) //对待审核产品进行审核
      }
    },
    review: {
      url: `${config.API_URL}/product`,
      name: "获取待审核商品列表",
      get: async function (params) {
        return await http.get(`${this.url}/manage/toReviewList`, params)
      },
      review: async function (data) {
        return await http.post(`${this.url}/manage/review`, data) //对待审核产品进行审核
      }
    }
  },

  groupActive: {
    list: {
      url: `${config.API_URL}/groupactivity`,
      name: "拼团活动",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      },
      startGroup: async function (data) {
        return await http.post(`${this.url}/startGroup`, data) // 开团
      },
      dropGroupMember: async function (data) {
        return await http.post(`${this.url}/dropGroupMember`, data) // 取消拼团
      }
    }
  },
  groupOrder: {
    list: {
      url: `${config.API_URL}/groupOrder`,
      name: "拼团订单",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      }
    }
  },
  groupMember: {
    list: {
      url: `${config.API_URL}/groupMember`,
      name: "拼团订单",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      }
    }
  },
  order: {
    list: {
      url: `${config.API_URL}/order`,
      name: "获取商品",
      get: async function (params) {
        return await http.get(`${this.url}/manage/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      }
    }
  },
  user: {
    list: {
      url: `${config.API_URL}/user`,
      name: "获取用户",
      get: async function (params) {
        return await http.get(`${this.url}/userlist`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/user/manage/updateUser`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      }
    }
  },
  dict: {
    url: `${config.API_URL}/dict`,
    name: "获取字典",
    get: async function (params) {
      return await http.get(`${this.url}/listTree`, params)
    },
    submit: async function (data) {
      return await http.post(`${this.url}/submit`, data)
    },
    del: async function (data) {
      return await http.post(`${this.url}/delete`, data)
    },
    dictList: async function (params) {
      return await http.get(`${this.url}/list`, params)
    }
  },
  permission: {
    list: {
      url: `${config.API_URL}/permission`,
      name: "获取角色列表",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/submit`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      }
    }
  }
}
